// 导入request 
import request from './request'

import { getCookie } from '@/utils/cookie.js'
const http = {
    /**
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url, params, contentType = true, responseType = false) {
        const config = {
            method: 'get',
            url: url,
            headers: {
                'Content-Type': contentType ? 'application/json' : 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${getCookie('accessToken')}`,
                'tenant-id': getCookie('tenantId')
            }
        }
        if (responseType) {
            config.responseType = 'blob'
        }
        if (params) {
            config.params = params

        }
        return request(config)
    },
    post(url, data, contentType = true) {
        const config = {
            method: 'post',
            url: url,
            headers: {
                'Content-Type': contentType ? 'application/json' : 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${getCookie('accessToken')}`,
                'tenant-id': getCookie('tenantId')
            }
        }

        console.log("================")
        console.log(config)

        if (!contentType) {
            if (process.client) {
                var formData = new FormData();
                for (let key in data) { formData.append(key, data[key]) }
            }
        }
        if (data) config.data = contentType ? data : formData
        return request(config)
    },
}


export default http